module.exports = __webpack_public_path__ + "img/icon7.4175ce6b.png";